import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import Draggable from '~/components/Draggable';

function CardText({ title, description, nameColor, hasTitle }) {
    return (
        <>
            <Title
                hasTitle={hasTitle}
                nameColor={nameColor}
                title={title}
            />
            <Description description={description} />
        </>
    );
}

CardText.defaultProps = {
    title: '',
    description: null,
    hasTitle: true,
};

CardText.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    nameColor: PropTypes.string.isRequired,
    hasTitle: PropTypes.bool,
};

export default React.memo(CardText);

// eslint-disable-next-line react/prop-types
function Title({ hasTitle, nameColor, title }) {
    return (
        <>
            {hasTitle && (
                <Draggable fieldName="draggableName">
                    <h3
                        style={{ lineHeight: 1, textAlign: 'center', color: nameColor }}
                        className="m-2"
                    >
                        {title}
                    </h3>
                </Draggable>
            )}
        </>
    );
}

// eslint-disable-next-line react/prop-types
function Description({ description }) {
    return (
        <Draggable fieldName="draggableDescription">
            <div
                id="cardText"
                className="text-white mb-0 m-2"
                style={{ lineHeight: 1 }}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(description),
                }}
            ></div>
        </Draggable>
    );
}
